import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-perfil-resume',
  templateUrl: './modal-perfil-resume.component.html',
  styleUrls: ['./modal-perfil-resume.component.scss']
})
export class ModalPerfilResumeComponent implements OnInit {

  constructor(
    private _dialogRef: MatDialogRef<ModalPerfilResumeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title: string, resume: string} = {title: "", resume: ""},
  ) { }

  ngOnInit(): void {
  }

  btnClose() { this._dialogRef.close(); }

}
